export const SITE = {
  // Header
  header: 'site-header',
  logo: 'site-logo',
  navHome: 'nav-home',
  navServices: 'nav-services',
  navAdvantages: 'nav-advantages',
  navProcess: 'nav-process',
  navFaq: 'nav-faq',
  navContact: 'nav-contact',
  langToggle: 'lang-toggle',
  langFr: 'lang-fr',
  langEn: 'lang-en',
  ctaHeader: 'cta-header',
  mobileMenuToggle: 'mobile-menu-toggle',

  // Hero
  hero: 'hero-section',
  heroTitle: 'hero-title',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',

  // Sections
  sectionProblem: 'section-problem',
  sectionSolution: 'section-solution',
  sectionServices: 'section-services',
  sectionAdvantages: 'section-advantages',
  sectionApproach: 'section-approach',
  sectionProcess: 'section-process',
  sectionAudience: 'section-audience',
  sectionStats: 'section-stats',
  sectionTestimonials: 'section-testimonials',
  sectionFaq: 'section-faq',
  sectionContact: 'section-contact',

  // Cards
  challengeCard: 'challenge-card',
  solutionCard: 'solution-card',
  serviceCard: 'service-card',
  advantageItem: 'advantage-item',
  pillarItem: 'pillar-item',
  processStep: 'process-step',
  audienceCard: 'audience-card',
  testimonialCard: 'testimonial-card',

  // CTA buttons
  advantagesCta: 'advantages-cta',

  // FAQ
  faqItem: 'faq-item',

  // Contact form
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactOrganization: 'contact-organization',
  contactFacilityType: 'contact-facility-type',
  contactEmail: 'contact-email',
  contactPhone: 'contact-phone',
  contactMessage: 'contact-message',
  contactSubmit: 'contact-submit',
  contactSuccess: 'contact-success',

  // Cookies
  cookieBanner: 'cookie-banner',
  cookieAccept: 'cookie-accept',
  cookieDecline: 'cookie-decline',
  cookieLearnMore: 'cookie-learn-more',

  // Privacy page
  privacyPage: 'privacy-page',
  privacyBackHome: 'privacy-back-home',
  privacyFooterLink: 'privacy-footer-link',

  // Footer
  footer: 'site-footer',
};
